import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatTargetRate } from '@/shared/lib/utils';
import { StatTile } from '@/shared/ui';

type Props = {
  /** Всего диалогов в выборке */
  totalDialogs: number;
  /** Доля целевого исхода по всей выборке (0..1) */
  baselineRate: number | null;
  /** Число надёжных переходов (n ≥ порога) */
  reliableCount: number;
};

/**
 * Строка KPI раздела «Переходы»: объём выборки, базовая доля цели и число надёжных переходов.
 */
export const TransitionsKpi: FC<Props> = ({ totalDialogs, baselineRate, reliableCount }) => {
  const { t } = useTranslation('strategist');

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <StatTile label={t('transitions.kpi.totalDialogs')}>{totalDialogs.toLocaleString()}</StatTile>
      <StatTile label={t('transitions.kpi.baselineRate')}>{formatTargetRate(baselineRate)}</StatTile>
      <StatTile label={t('transitions.kpi.reliableTransitions')}>{reliableCount.toLocaleString()}</StatTile>
    </div>
  );
};
